// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 232
// module chunks = 0